module.exports = __webpack_public_path__ + "img/5573ff6c75ac9b3bb3842c43b5ad0d65.png";